{
  "toasts": {
    "apiKeyGenerated": "¡Clave de API generada correctamente!",
    "apiKeyGenerateError": "Error al generar la clave de API",
    "apiKeyRegenerated": "¡Clave de API regenerada correctamente!",
    "apiKeyRegenerateError": "Error al regenerar la clave de API"
  },
  "page": {
    "title": "Configuración",
    "subtitle": "Ajusta todo lo de tu plataforma en un solo lugar: aspecto visual, emails, integraciones y seguridad."
  },
  "tabs": {
    "overview": "Visión general",
    "api": "API y seguridad",
    "terms": "Términos de uso",
    "language": "Idioma"
  },
  "actions": {
    "cancel": "Cancelar"
  },
  "hub": {
    "recursos": {
      "title": "Funciones",
      "description": "Activa o desactiva la comunidad, los certificados y la gamificación para tus alumnos."
    },
    "domains": {
      "title": "Direcciones",
      "description": "La dirección por la que entran tus alumnos: usa el subdominio listo o apunta un dominio propio."
    },
    "branding": {
      "title": "Identidad visual",
      "description": "Logo, imagen de la pantalla de acceso, favicon y los colores de tu marca."
    },
    "emailTemplates": {
      "title": "Plantillas de email",
      "description": "Edita los emails que se envían automáticamente en cada evento (bienvenida, inscripción, etc.)."
    },
    "webhooks": {
      "title": "Webhooks",
      "description": "Notifica a sistemas externos cuando ocurren eventos (inscripción, pago, etc.)."
    },
    "surveys": {
      "title": "Encuestas",
      "description": "Crea encuestas segmentadas por alumno, curso o periodo, con NPS, escalas y más."
    }
  },
  "overview": {
    "introTitle": "Empieza por lo más importante",
    "introDescription": "Este es el centro de configuración de la plataforma. Haz clic en cualquier tarjeta de abajo para personalizar un área concreta. Para claves de API, seguridad o subir el contrato de términos de uso, usa las pestañas de arriba.",
    "areas": "Áreas de configuración",
    "quickSettings": "Configuración rápida",
    "apiDescription": "Claves de API, tokens JWT y autenticación externa.",
    "termsDescription": "Sube el contrato que el alumno acepta al entrar."
  },
  "api": {
    "copied": "¡Copiado al portapapeles!",
    "explainerTitle": "¿Qué es una \"clave de API\"?",
    "explainerDescription": "Es una contraseña especial que permite que <bold>otros sistemas</bold> se comuniquen con tu plataforma (p. ej.: un CRM, una app móvil, una automatización de Zapier). Genérala solo si sabes dónde la vas a usar, y nunca la compartas públicamente.",
    "keyTitle": "Clave de API",
    "keyDescription": "Usa esta clave para autenticar llamadas externas a la API de la plataforma.",
    "saveNowTitle": "¡Guarda esta clave ahora!",
    "saveNowDescription": "Esta clave no se volverá a mostrar. Cópiala y guárdala en un lugar seguro.",
    "savedConfirm": "Entendido, ya la guardé",
    "createdAt": "Creada el {{date}}",
    "active": "Activa",
    "regenerating": "Regenerando...",
    "regenerate": "Regenerar clave",
    "regenerateConfirmTitle": "¿Regenerar la clave de API?",
    "regenerateConfirmDescription": "La clave actual se invalidará de inmediato. Cualquier integración que use la clave antigua dejará de funcionar.",
    "regenerateAction": "Regenerar",
    "generating": "Generando...",
    "generate": "Generar clave de API",
    "tokenTitle": "Token de acceso",
    "tokenDescription": "Tu token JWT actual para llamadas autenticadas a la API.",
    "tokenExpiry": "Este token caduca en <bold>15 minutos</bold> y se renueva automáticamente. Úsalo en el header:",
    "noToken": "No hay ningún token disponible. Vuelve a iniciar sesión."
  },
  "terms": {
    "toasts": {
      "updated": "¡Contrato actualizado correctamente!",
      "uploadError": "Error al subir el contrato",
      "removed": "Contrato eliminado",
      "removeError": "Error al eliminar el contrato",
      "urlError": "Error al guardar el enlace del contrato"
    },
    "explainerTitle": "Contrato que el alumno acepta al entrar",
    "explainerDescription": "Cuando el alumno inicia sesión por primera vez, tiene que <bold>aceptar los términos</bold>. El archivo que subas aquí es el que verá para leerlo. Sustitúyelo cuando quieras: la nueva versión se aplica a las nuevas aceptaciones.",
    "cardTitle": "Contrato de términos y condiciones",
    "currentContract": "Contrato actual",
    "openFile": "Abrir archivo",
    "remove": "Eliminar",
    "replace": "Sustituir",
    "emptyTitle": "No se ha subido ningún contrato",
    "emptyDescription": "Mientras no subas un archivo o enlace, tus alumnos no pasan por el paso de aceptación de términos.",
    "upload": "Subir contrato",
    "urlLabel": "Enlace del contrato",
    "urlPlaceholder": "O pega el enlace https del PDF del contrato",
    "saveUrl": "Usar enlace",
    "hint": "Acepta PDF, DOC y DOCX de hasta 10 MB. Si actualizas el archivo, plantéate avisar a los alumnos que ya aceptaron la versión anterior."
  },
  "recursos": {
    "items": {
      "community": {
        "name": "Comunidad",
        "description": "Espacio de conversación entre los alumnos, con publicaciones, comentarios y eventos."
      },
      "certificates": {
        "name": "Certificados",
        "description": "Emisión de certificado al completar un curso."
      },
      "gamification": {
        "name": "Gamificación",
        "description": "Puntos, niveles y ranking entre los alumnos."
      },
      "assistant": {
        "name": "Asistente de IA",
        "description": "Arma y sube cursos al área de miembros conversando contigo."
      }
    },
    "toasts": {
      "updated": "Función actualizada.",
      "updateError": "No se pudo cambiar."
    },
    "loading": "Cargando…",
    "title": "Funciones",
    "subtitle": "Lo que está disponible para tus alumnos.",
    "outOfPlan": "Fuera del plan",
    "turnOn": "Activar {{name}}",
    "turnOff": "Desactivar {{name}}",
    "notInPlan": "Esta función no está incluida en tu plan. Habla con Xtreed para activarla.",
    "community": {
      "toasts": {
        "updated": "Dirección de la comunidad actualizada.",
        "saveError": "No se pudo guardar."
      },
      "label": "Dirección de la comunidad",
      "save": "Guardar",
      "hint": "Déjalo en blanco para usar la dirección predeterminada de Xtreed. Una dirección propia tiene que estar en el mismo dominio que tu área de miembros."
    }
  },
  "domains": {
    "status": {
      "pending": "Esperando DNS",
      "verifying": "Verificando",
      "active": "Activo",
      "failed": "No encontrado"
    },
    "toasts": {
      "genericError": "No se pudo completar.",
      "created": "Dirección registrada. Configura el DNS para activarla.",
      "verified": "Dirección verificada.",
      "txtPending": "El registro TXT aún no aparece. El DNS puede tardar unas horas.",
      "primaryUpdated": "Dirección principal actualizada.",
      "removed": "Dirección eliminada.",
      "copyError": "No se pudo copiar. Selecciónalo y cópialo manualmente."
    },
    "title": "Direcciones",
    "subtitle": "Por donde entran tus alumnos. Puedes usar el subdominio que ya viene listo o apuntar un dominio propio.",
    "placeholder": "area.tuescuela.es",
    "newAddress": "Nueva dirección",
    "add": "Añadir",
    "loading": "Cargando direcciones…",
    "empty": "Aún no hay ninguna dirección registrada.",
    "primary": "Principal",
    "verify": "Verificar",
    "makePrimary": "Hacer principal",
    "remove": "Eliminar {{domain}}",
    "dnsInstructions": "Crea estos dos registros en el DNS de <bold>{{domain}}</bold>. La propagación suele tardar desde minutos hasta unas horas.",
    "txtExplanation": "Demuestra que el dominio es tuyo",
    "cnameExplanation": "Dirige el tráfico a la plataforma",
    "notFound": "No encontramos el registro. Confirma que se publicó y vuelve a verificar: el DNS puede tardar en propagarse.",
    "copyValue": "Copiar valor del registro {{type}}"
  },
  "language": {
    "title": "Idioma del área",
    "description": "Idioma de toda el área del alumno: menús, botones, mensajes y correos.",
    "label": "Idioma del área de miembros",
    "hint": "Los alumnos no pueden cambiar el idioma. Solo el equipo (admin e instructor) usa su propio idioma en el panel.",
    "saved": "Idioma predeterminado actualizado.",
    "saveError": "No se pudo guardar el idioma predeterminado."
  }
}
